import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusLock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFocusLock"><Path d="M3.5 8V3.5H8M3.5 16V20.5H8M16 3.5H20.5V8M20.5 16V20.5H16M8.5 10.5H15.5V15.5H8.5V10.5ZM14.5 10.5V10C14.5 8.61929 13.3807 7.5 12 7.5C10.6193 7.5 9.5 8.61929 9.5 10V10.5H14.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFocusLock;
